export type CampaignType = {
  startDateTime?: string;
  endDateTime?: string;
  extensionCount?: number;
};

export enum Campaigns {
  ENTERPRISE = 'customerEnterpriseCampaign',
  AI_CONFIGS = 'customerAIConfigsCampaign',
}
